module.exports = __webpack_public_path__ + "img/confirm-btn-exclude-white.98dcc98b.svg";